import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Container } from '@mui/material';
import { useSupabase } from '../contexts/SupabaseContext';
import { useParams } from 'react-router-dom';

const ResetPassword = () => {
  const { accessToken } = useParams(); // Get access token from URL
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const { supabase } = useSupabase();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword,
        access_token: accessToken // Use the access token for the update
      });

      if (error) {
        console.error('Error updating password:', error.message);
        throw error;
      }

      setMessage('Password updated successfully! You can now log in with your new password.');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">Reset Password</Typography>
        {error && <Typography color="error">{error}</Typography>}
        {message && <Typography color="success.main">{message}</Typography>}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="New Password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            Update Password
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ResetPassword;